import React from "react";
import { useNavigate } from "react-router-dom";
import CustomerPageLayout from "../customer-page-layout/CustomerPageLayout";
import Button from "../../../common/components/xepp/button/Button";
import CommonLoadingSpinner from "../../../common/components/loading-spinner/CommonLoadingSpinnerForPage";
import styles from './SavedBeneficiaries.module.scss';
import { PlusOnlyIcon, ChevronRightIcon } from "../../../assets/icons";
import {
	BeneficiaryItem,
	useGetBeneficiariesQuery,
} from "../../../service/beneficiary-service";


const getInitials = (name: string): string => {
	const parts = name.trim().split(/\s+/);
	if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
	return name.slice(0, 2).toUpperCase();
};

export const SavedBeneficiariesPage: React.FC = () => {
	const navigate = useNavigate();
	const { data, isLoading, isError, refetch } = useGetBeneficiariesQuery();

	return (
		<CustomerPageLayout
			title="Saved Beneficiaries"
			headerAction={<Button text="Add" rightIcon={<PlusOnlyIcon/>} variant="outline" className={styles.addBtn} onClick={() => navigate("add")} />}
			
		>
			<div className={styles.pageContainer}>
			
			<CommonLoadingSpinner loading={isLoading}>
				<></>
			</CommonLoadingSpinner>

			{!isLoading && isError && (
				<div className={styles.statusBlock}>
					<span>Couldn't load beneficiaries.</span>
					<button type="button" className={styles.retryBtn} onClick={() => refetch()}>
						Retry
					</button>
				</div>
			)}

			{!isLoading && !isError && (data ?? []).length === 0 && (
				<div className={styles.statusBlock}>
					<span className={styles.emptyTitle}>No saved beneficiaries yet.</span>
					<span className={styles.emptyHint}>
						Save a meter after a successful purchase and it'll show up here next time.
					</span>
				</div>
			)}

			{!isLoading && !isError && (data ?? []).length > 0 && (
				<ul className={styles.list}>
					{(data as BeneficiaryItem[]).map(b => (
						<li key={b.id} className={styles.row} onClick={() => navigate(`${b.id}`)}>
							<div className={styles.initContainer}>
								{getInitials(b.customerName || b.identifier)}
							</div>
							<div className={styles.rowMain}>
								<span className={styles.rowName}>{ b.identifier}</span>
								{b.address && <span className={styles.rowAddress}>{b.address}</span>}
							</div>
							<ChevronRightIcon className={styles.rowChevron} />
						</li>
					))}
				</ul>
			)}
			</div>
		</CustomerPageLayout>
	);
};
